import axios from "axios";
import { BASEDOMAIN } from "@/constants/allconstants";
import { AuthConfig, Config } from "@/utils/constants/configContants";
import { getToken } from "@/utils/functions/TokenFunction";
import { errorToasterMessage } from "@/utils/functions/toaster";

export const fetchSetting = async (callback: any, errorCallback: any) => {
    await axios
        .get(`${BASEDOMAIN}/setting`, AuthConfig())
        .then((response) => {
            callback(response?.data);
        })
        .catch((e) => {
            errorCallback(e?.response?.data);
        });
};

export const fetchWebhook = async (callback: any, errorCallback: any) => {
    axios
        .get(`${BASEDOMAIN}/setting/webhook`, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            console.log(e);
            errorCallback(e?.response?.data);
        });
};

export const saveWebhook = async (data: any, callback?: any, errorCallback?: any) => {
    await axios
        .put(`${BASEDOMAIN}/setting/webhook`, data, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errorCallback(e?.response);
        });
};

export const fetchLogoutRedirect = async (callback: any, errorCallback: any) => {
    axios
        .get(`${BASEDOMAIN}/setting/logout-redirect`, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            console.log(e);
            errorCallback(e?.response?.data);
        });
};

export const saveLogoutRedirect = async (data: any, errorCallback?: any) => {
    await axios
        .put(`${BASEDOMAIN}/setting/logout-redirect`, data, AuthConfig())
        .catch((e) => {
            errorCallback(e?.response);
        });
};

export const fetchConfig = async (query: any, callback: any, errCallBack: any) => {
    let url = `${BASEDOMAIN}/setting/configurations`;
    if (query?.id) {
        url = url + `?id=${query.id}`
    }
    await axios.get(url, AuthConfig()).then(res => {
        callback(res.data)
    }).catch(e => errCallBack(e))
}

export const patchConfiguration = async (patchData: any) => {
    const patchResult = await axios.patch(`${BASEDOMAIN}/setting/configurations`, patchData, AuthConfig());
    return patchResult;
};

export const getAzureConfiguration = async () => {
    const result = await axios.get(`${BASEDOMAIN}/setting/azure`, AuthConfig());
    return result.data;
};

export const postAzureConfiguration = async (data: any) => {
    const result = await axios.post(`${BASEDOMAIN}/setting/azure`, data, AuthConfig());
    return result;
};

export const patchAzureConfiguration = async (data: any) => {
    const result = await axios.patch(`${BASEDOMAIN}/setting/azure`, data, AuthConfig());
    return result;
};

export const postStatus = async (is_active: any, callback: any) => {
    await axios.patch(`${BASEDOMAIN}/setting/azure`, { is_active }, AuthConfig()).then((res) => callback(res.data));
};

export const getFeaturesListFromAPI = async () => {
    const result = await axios.get(`${BASEDOMAIN}/feature/list`, AuthConfig());
    return result;
};

export const getBrandList = async (callback: any, errCallback: any) => {
    await axios
        .get(`${BASEDOMAIN}/setting/brand/list`, AuthConfig())
        .then((response) => {
            callback(response.data);
        })
        .catch((e) => {
            errCallback(e);
            console.log(e);
        });
};

export const getBrandById = async (id: string, callback: any, errCallback: any) => {
    await axios
        .get(`${BASEDOMAIN}/setting/brand/${id}`, AuthConfig())
        .then((response) => {
            callback(response.data);
        })
        .catch((e) => {
            errCallback(e);
        });
};

export const deleteBrand = async (id: string, callback: any, errCallback: any) => {
    await axios
        .delete(`${BASEDOMAIN}/setting/brand/${id}`, AuthConfig())
        .then((response) => {
            callback(response.data);
        })
        .catch((e) => {
            errCallback(e);
        });
};
export const postBrand = async (data: any, callback: any, errCallback: any) => {
    await axios
        .post(`${BASEDOMAIN}/setting/brand`, data, AuthConfig())
        .then((response) => {
            callback(response);
        })
        .catch((e) => {
            errCallback(e.response?.data);
        });
};
/**
 * 
 * @param token 
 * @param data 
 * @param callback 
 * @param errorCallback 
 */
export const addOrganizationADCredentials = async (token: string, data: any, callback: any, errorCallback: any) => {
    axios.post(`${BASEDOMAIN}/integration/directory?token=${token}`, data, Config())
        .then((response) => {
            callback(response.data)
        }).catch((e) => {
            errorCallback(e?.response?.data?.message)
        });
}

export const getConnector = async (query: any, callback: any, errorCallback: any) => {
    let url = `${BASEDOMAIN}/integration/directory`
    if (query.connectorFor) {
        url = `${url}?connectorFor=${query.connectorFor}`
    }
    if (query.type) {
        url = `${url}?type=${query.type}`
    }
    axios.get(url, AuthConfig())
        .then((response) => {
            callback(response.data)
        }).catch((e) => {
            errorCallback(e?.response?.data?.message)
        });
}

export const fetchAllConnector = async (query: any, callback: any, errorCallback: any) => {
    let url = `${BASEDOMAIN}/integration/directory/connector`
    if (query.type) {
        url = url + `?type=${query.type}`
    }
    axios.get(url, AuthConfig())
        .then((response) => {
            callback(response.data)
        }).catch((e) => {
            errorCallback(e?.response?.data?.message)
        });
}

export const fetchConfigByOrganizationId = async (organization_id: string, callback: any, errCallBack: any) => {
    await axios.get(`${BASEDOMAIN}/setting/${organization_id}/configurations`, AuthConfig()).then(res => {
        callback(res.data)
    }).catch(e => errCallBack(e))
}

export const updateDirectory = async (id: string, data: any, callback: any, errCallBack: any) => {
    await axios.patch(`${BASEDOMAIN}/integration/directory/${id}`, data, AuthConfig())
    .then(res => {
        callback(res.data)
    })
    .catch(e => errCallBack(e))
}

export const updateConnector = async (id: string, data: any, callback: any, errCallBack: any) => {
    await axios.patch(`${BASEDOMAIN}/integration/${id}`, data, AuthConfig())
    .then(res => {
        callback(res.data)
    })
    .catch(e => errCallBack(e))
}

export const tokenForConsent = async (data: any, callback: any, errCallBack: any) => {
    try {
        const response = await axios.post(`${BASEDOMAIN}/integration/directory-token`, data, AuthConfig())
        callback(response.data)
    } catch (err) {
        errCallBack(err)
        console.log(err)
    }
}

export const uploadSmalXMLConfigFile = async (formData: any, callback: any, errCallBack: any) => {
    try {
        const response = await axios.post(`${BASEDOMAIN}/integration/saml-config-xml`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${getToken()}` // Example token retrieval
            },
        });
        callback(response)
    } catch (err: any) {
        console.log(err?.response)
        errCallBack(err)
    }
}

export const postAiConfiguration = async (data: any, callback: any, errCallBack: any) => {
    await axios.post(`${BASEDOMAIN}/setting/ai`, data, AuthConfig())
    .then(res => {
        callback(res.data)
    })
    .catch(e => errCallBack(e))
}

export const getAiConfiguration = async (callback: any, errCallBack: any) => {
    await axios.get(`${BASEDOMAIN}/setting/ai`, AuthConfig())
    .then(res => {
        callback(res.data)
    })
    .catch(e => errCallBack(e?.response?.data?.message))
}

export const getAiConfigurationById = async (id: string, callback: any, errCallBack: any) => {
    await axios.get(`${BASEDOMAIN}/setting/ai/${id}`, AuthConfig())
    .then(res => {
        callback(res.data)
    })
    .catch(e => errCallBack(e?.response?.data?.message))
}

export const patchAiConfiguration = async (data: any, callback: any, errCallBack: any) => {
    await axios.patch(`${BASEDOMAIN}/setting/ai`, data, AuthConfig())
    .then(res => {
        callback(res.data)
    })
    .catch(e => errCallBack(e?.response?.data?.message))
}

export const revokeAiConfiguration = async (id: string, callback: any, errCallBack: any) => {
    await axios.delete(`${BASEDOMAIN}/setting/ai/${id}`, AuthConfig())
    .then(res => {
        callback(res.data)
    })
    .catch(e => errCallBack(e?.response?.data?.message))
}

export const getLLMProviderList = async (callback: any) => {
    await axios.get(`${BASEDOMAIN}/llm/providers`, AuthConfig())
    .then(res => {
        callback(res.data)
    })
}